import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';
import { SxStyle } from '../../../types';
import { drawerWidth } from '../../../constants';
import { SxProps } from '@mui/material';

const styles: SxStyle = {
  content: {
    height: 'calc(100% - 56px)',
    paddingLeft: '24px',
    paddingRight: '24px',
    overflow: 'auto',
    paddingTop: '20px',
    marginTop: '60px',
  },
  contentWithTabs: {
    padding: '24px',
    paddingBottom: '65px',
    height: 'calc(100% - 50px)',
    overflow: 'auto',
  },
  contentWithOverheadTabs: {
    padding: '24px',
    paddingBottom: '65px',
    height: 'calc(100% - 140px)',
    overflow: 'auto',
  },
};

export interface SceneContentProps {
  children: ReactNode;
  withTabsInside?: boolean;
  withTabsAbove?: boolean;
  noHorizontalPadding?: boolean;
}

function SceneContent({
  children,
  withTabsInside,
  withTabsAbove,
  noHorizontalPadding,
}: SceneContentProps) {
  let contentStyle = styles.content;
  if (withTabsInside) {
    contentStyle = styles.contentWithTabs;
  } else if (withTabsAbove) {
    contentStyle = styles.contentWithOverheadTabs;
  }

  const combinedStyles: SxStyle = {
    content: (theme) => ({
      [theme.breakpoints.up('sm')]: {
        marginLeft: `${drawerWidth}px`,
      },
      ...contentStyle,
      ...(noHorizontalPadding
        ? {
            paddingX: 0,
          }
        : ({} as SxProps)),
    }),
  } as const;

  return <Box sx={combinedStyles.content}>{children}</Box>;
}

export default SceneContent;
